import * as React from 'react';
const AvatarContext = /*#__PURE__*/React.createContext({
  size: 'default',
  shape: undefined
});
export default AvatarContext;